const hasSpecialCharacters = (value: string): boolean | string => {
  const specialCharacters = /([^\d|\s|a-zA-Z\u00C0-\u00FF])/gi;
  return (
    !specialCharacters.test(value) ||
    'Esse campo não pode conter caracteres especiais'
  );
};

export { hasSpecialCharacters };
